/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_UpdateInputs */

const en_agent_authorization_permission_update = /** @type {(inputs: Agent_Authorization_Permission_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update this project's submitted details`)
};

const zh_agent_authorization_permission_update = /** @type {(inputs: Agent_Authorization_Permission_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新当前项目已提交的资料`)
};

/**
* | output |
* | --- |
* | "Update this project's submitted details" |
*
* @param {Agent_Authorization_Permission_UpdateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_update = /** @type {((inputs?: Agent_Authorization_Permission_UpdateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_UpdateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_update(inputs)
	return zh_agent_authorization_permission_update(inputs)
});
export { agent_authorization_permission_update as "agent.authorization.permission.update" }